import { mono } from '@components/systems/monolith/monolith.tokens'

/**
 * 주문 목록 밴드 — 주문 하나 = 헤어라인 밴드 하나(머리: 주문번호 · 상태 · 날짜 / 본문: 2열 블록).
 * My Order 에서 빼냈다(2026-10-06) — Wholesale Orders 가 같은 모양을 쓴다. 페이지 css() 안에서
 * customerAccountStyle 뒤에 스프레드한다.
 */
export const customerOrderListStyle = {
	'.mnOrderList': {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
	},

	'.mnOrder': {
		borderTop: `1px solid ${mono.line}`,
		padding: 'clamp(36px, 4vw, 56px) 0',
		display: 'flex',
		flexDirection: 'column',
		gap: 'clamp(28px, 3vw, 44px)',

		'&:last-of-type': {
			borderBottom: `1px solid ${mono.line}`,
		},
	},

	'.mnOrderHead': {
		display: 'flex',
		alignItems: 'flex-end',
		justifyContent: 'space-between',
		gap: 24,
		flexWrap: 'wrap',

		'.mnOrderHeadLeft': {
			display: 'flex',
			flexDirection: 'column',
			gap: 12,

			'.mnOrderNo': {
				fontSize: 'clamp(28px, 2.8vw, 40px)',
				lineHeight: 1.1,
				fontWeight: 300,
				color: mono.ink,
				fontVariantNumeric: 'tabular-nums',
			},
		},

		'.mnOrderHeadRight': {
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'flex-end',
			gap: 10,

			'.mnOrderStatus': {
				color: mono.ink,
			},

			'@media (max-width: 600px)': {
				alignItems: 'flex-start',
			},
		},
	},

	'.mnOrderDetail': {
		display: 'grid',
		gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
		gap: 'clamp(32px, 4vw, 56px)',

		'@media (max-width: 900px)': {
			gridTemplateColumns: '1fr',
		},
	},

	'.mnOrderBlock': {
		display: 'flex',
		flexDirection: 'column',
		gap: 18,
	},

	'.mnOrderItemList': {
		display: 'flex',
		flexDirection: 'column',

		'.mnOrderItem': {
			display: 'flex',
			alignItems: 'baseline',
			justifyContent: 'space-between',
			gap: 20,
			padding: '14px 0',
			borderBottom: `1px solid ${mono.line}`,

			'.mnOrderItemName': {
				fontSize: 16,
				fontWeight: 400,
				color: mono.ink,
			},
			'.mnOrderItemQty': {
				fontSize: 13,
				fontWeight: 500,
				color: mono.faint,
				fontVariantNumeric: 'tabular-nums',
			},
		},
	},

	'.mnOrderTable': {
		display: 'flex',
		flexDirection: 'column',

		'.mnOrderTableRow': {
			display: 'grid',
			gridTemplateColumns: 'minmax(0, 140px) minmax(0, 1fr)',
			gap: 20,
			padding: '13px 0',
			borderBottom: `1px solid ${mono.line}`,

			'> span:first-of-type': {
				fontSize: 13,
				letterSpacing: '.14em',
				textTransform: 'uppercase',
				fontWeight: 500,
				color: mono.faint,
			},
			'> span:last-of-type': {
				fontSize: 16,
				fontWeight: 300,
				color: mono.ink,
				fontVariantNumeric: 'tabular-nums',
				wordBreak: 'break-word',
			},

			'&.total > span:last-of-type': {
				fontWeight: 400,
			},

			'@media (max-width: 600px)': {
				gridTemplateColumns: '1fr',
				gap: 6,
			},
		},
	},
} as const
